module.exports = __webpack_public_path__ + "static/bruno_jelencic-127b1357fbb68c055222b1dbebb34529.png";